import {DeadlineStickerValue, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {systemStickerCtl} from '@extensions/sticker/sticker'

export const sortByDeadlineNew = (tasks: Hub[]): Hub[] => {
  const box = Sync.getCurrentSandbox()
  const deadLineSticker = systemStickerCtl.Deadline.getSticker(box)

  return tasks.sort((b, a) => {
    const aData = a.stickers[deadLineSticker.id] as DeadlineStickerValue
    const bData = b.stickers[deadLineSticker.id] as DeadlineStickerValue

    if (aData && bData) {
      return aData.current.deadline - bData.current.deadline
    }

    if (aData) {
      return 1
    }

    if (!aData && !bData) {
      return 0
    }

    return -1
  })
}

export const sortByDeadlineOld = (tasks: Hub[]): Hub[] => {
  const box = Sync.getCurrentSandbox()
  const deadLineSticker = systemStickerCtl.Deadline.getSticker(box)

  return tasks.sort((b, a) => {
    const aData = a.stickers[deadLineSticker.id] as DeadlineStickerValue
    const bData = b.stickers[deadLineSticker.id] as DeadlineStickerValue

    if (aData && bData) {
      return bData.current.deadline - aData.current.deadline
    }

    if (aData) {
      return 1
    }

    if (!aData && !bData) {
      return 0
    }

    return -1
  })
}
